import ModernOpportunityDetail from '../components/ModernOpportunityDetail';

// /opportunities/:slug — one expanded layout for every brand (s153): the
// «Moderno» Gallery + Section Nav page approved in s141, skinned per theme
// (fonts, dark panel, accent, radius) inside ModernOpportunityDetail.
export default function OpportunityDetailPage() {
  return <ModernOpportunityDetail />;
}
